/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function SubCustomerDetailsController(userService, subCustomerService) {

    var vm = this;

    vm.$onInit = function () {
        loadSubCustomer();
    };

    function loadSubCustomer() {
        subCustomerService.getSubCustomer(userService.getCurrentUser().subCustomerId).then(
            (subCustomer) => {
                vm.subCustomer = subCustomer;
            }
        );
    }


}



// WEBPACK FOOTER //
// ./src/app/subcustomer/subcustomer-details.controller.js